import React, { useEffect, useState } from "react";

export default function Verification({ title, subtitle, duration = 15000, onDone }) {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    const startedAt = Date.now();
    const interval = setInterval(() => {
      const passed = Date.now() - startedAt;
      setElapsed(passed);
      if (passed >= duration) {
        clearInterval(interval);
        setTimeout(onDone, 350);
      }
    }, 120);
    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, []);

  const progress = Math.min(100, (elapsed / duration) * 100);
  const R = 96;
  const CIRC = 2 * Math.PI * R;

  return (
    <section className="screen vfx-screen vfx-min" data-testid="verification-screen">
      <div className="vfx-min-content">
        {/* Brand */}
        <div className="vfx-min-brand">
          <div className="vfx-min-logo">
            <img src="/assets/logo.png" alt="" />
          </div>
          <div className="vfx-min-name">Pulpay Kredit</div>
        </div>

        {/* Ring with logo center + orbiting spark */}
        <div className="vfx-min-ring">
          <div className="vfx-min-halo" />
          <div className="vfx-min-halo vfx-min-halo-2" />
          <svg viewBox="0 0 240 240" className="vfx-min-ring-svg">
            <defs>
              <linearGradient id="vfxMinGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%"  stopColor="#e6f2ff" />
                <stop offset="55%" stopColor="#7fc0ff" />
                <stop offset="100%" stopColor="#4a90ff" />
              </linearGradient>
              <linearGradient id="vfxMinGrad2" x1="100%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%"  stopColor="rgba(180,220,255,.55)" />
                <stop offset="100%" stopColor="rgba(120,180,255,.05)" />
              </linearGradient>
            </defs>
            {/* Outer dashed decorative ring */}
            <circle cx="120" cy="120" r="112" fill="none"
                    stroke="rgba(255,255,255,.22)" strokeWidth="1.5"
                    strokeDasharray="2 8" className="vfx-min-ring-outer" />
            {/* Inner counter-rotating dashed ring */}
            <circle cx="120" cy="120" r="78" fill="none"
                    stroke="url(#vfxMinGrad2)" strokeWidth="1"
                    strokeDasharray="3 6" className="vfx-min-ring-inner" />
            {/* Background track */}
            <circle cx="120" cy="120" r={R} fill="none"
                    stroke="rgba(255,255,255,.18)" strokeWidth="12" />
            {/* Progress ring */}
            <circle cx="120" cy="120" r={R} fill="none"
                    stroke="url(#vfxMinGrad)" strokeWidth="12"
                    strokeLinecap="round"
                    strokeDasharray={`${(progress/100) * CIRC} ${CIRC}`}
                    transform="rotate(-90 120 120)"
                    style={{ transition: "stroke-dasharray .25s linear",
                             filter: "drop-shadow(0 4px 18px rgba(150,210,255,.65))" }} />
          </svg>

          {/* Orbiting sparks - 3 dots at varying speeds */}
          <div className="vfx-min-spark-track">
            <span className="vfx-min-spark" />
          </div>
          <div className="vfx-min-spark-track vfx-min-spark-track-2">
            <span className="vfx-min-spark vfx-min-spark-sm" />
          </div>
          <div className="vfx-min-spark-track vfx-min-spark-track-3">
            <span className="vfx-min-spark vfx-min-spark-xs" />
          </div>

          <div className="vfx-min-center">
            <div className="vfx-min-center-inner">
              <img src="/assets/logo.png" alt="PULPAY" />
            </div>
          </div>
        </div>

        {/* Text */}
        <h2 className="vfx-min-title">
          {title || (
            <>
              Limitiniz<br />yoxlanılır<span className="vfx-min-ellipsis">...</span>
            </>
          )}
        </h2>
        <span className="vfx-min-dots"><i /><i /><i /></span>
        <p className="vfx-min-sub">
          {subtitle || "Zəhmət olmasa bir neçə dəqiqə gözləyin."}
        </p>
      </div>
    </section>
  );
}
